import { render, staticRenderFns } from "./SiteMessageBannerCarousel.vue?vue&type=template&id=33a3ea56&scoped=true&lang=pug"
import script from "./SiteMessageBannerCarousel.vue?vue&type=script&lang=js"
export * from "./SiteMessageBannerCarousel.vue?vue&type=script&lang=js"
import style0 from "./SiteMessageBannerCarousel.vue?vue&type=style&index=0&id=33a3ea56&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a3ea56",
  null
  
)

export default component.exports